<div>
    <nz-spin [nzSpinning]="isLoading || isSavingOrAssigning">
        <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 20px;">
            <div style="flex: 1; padding: 0 20px; overflow: hidden; min-width: 0;">

                <nz-steps nzSize="small" [nzCurrent]="getIncidentActionCurrentStep()">
                @for (step of incidentActionSteps; track $index) {
                    <ng-template #stepIcon>
                    <nz-icon [nzType]="step.icon" [style.color]="step.dotColor" style="font-size: 16px;"></nz-icon>
                    </ng-template>
                    <ng-template #stepTitle>
                    <span [style.color]="step.dotColor" style="font-size: 15px; font-weight: 600; ">{{ step.title }}</span>
                    </ng-template>
                    <ng-template #stepDesc>
                    <small [style.color]="step.description ? step.dotColor : '#bfbfbf'" style="white-space: pre;">
                        {{ step.description || '—' }}
                    </small>
                    </ng-template>
                    <nz-step
                    [nzTitle]="stepTitle"
                    [nzDescription]="stepDesc"
                    [nzIcon]="stepIcon"
                    >
                    </nz-step>
                }
                </nz-steps>
            
            </div>
            <!-- <button nz-button (click)="sharedDataService.isWhatsappDrawerVisible=true" ><i nz-icon nzType="whats-app" nzTheme="outline"></i></button>        -->
        </div>
        <div nz-row [nzJustify]="'center'" style="margin-bottom: 25px;">
            <div nz-col [nzSpan]="16">
                Breakdown #: {{incident.incidentId && incident.incidentId > 0 ? incident.incidentNumber : 'NEW BREAKDOWN'}}
                @if (incident.orderNumber && !editOrderNumber) {
                    / <span style="font-weight: bold; cursor: pointer;" (click)="editOrderNumber = true" nz-tooltip="Click to edit order number">{{incident.orderNumber}}</span><br />
                } @if (editOrderNumber || !incident.orderNumber) {
                    <input nz-input nzSize="default" placeholder="Enter order number (optional)" id="orderNumber" name="orderNumber" type="text" [(ngModel)]="incident.orderNumber" [appValidationBorder]="incident.orderNumber" style="width: 200px; margin-left: 12px;" (blur)="editOrderNumber = false; onClickUpdateAndRegisterBreakdown()" (keydown.enter)="editOrderNumber = false; onClickUpdateAndRegisterBreakdown()" />
                }
            </div>
  
                @if (authService.isClientServiceProvider && incident.incidentId > 0 && incident.statusId > 4 && incident.statusId < 7) {
                    <div>
                        <button nz-button nzType="default" nzSize="large" (click)="isDelayDrawerVisible = true" [nzLoading]="isLoading" style="float: right;">
                            <nz-icon nzType="clock-circle" nzTheme="outline" /> Log a Delay
                        </button>
                    </div>
                } ,

            <div nz-col [nzSpan]="4" style="display: flex; align-items: center; gap: 8px; justify-content: flex-end;">
                <app-incident-chat [incidentId]="chatIncidentId || incident.incidentId" [incidentNumber]="incident.incidentId === (chatIncidentId || incident.incidentId) ? incident.incidentNumber : ''"
                      [senderType]="chatSender" [refreshKey]="incident" [chatEscalations]="incident.chatEscalations" />
                @if (incident.statusId < 10 && incident.incidentId && incident.incidentId > 0 && (authService.isClientCallCentre || authService.isClientFleet)) {
                    <button nz-button nzType="default" nzDanger nzSize="large" (click)="onClickCancelIncident()" [nzLoading]="isLoading">
                        <nz-icon nzType="close-circle" nzTheme="outline" /> Cancel Breakdown
                    </button>
                }
            </div>
        </div>
        @if (mustDisplayServiceProviderAcceptReject()) {
            <div nz-row [nzJustify]="'center'" >
                <div nz-col [nzSpan]="20">
                    <nz-card nzTitle="Do you accept this breakdown?" [nzBordered]="true" style="margin-bottom: 20px;">
                        <div nz-row [nzGutter]="16">
                            <div nz-col [nzSpan]="16">
                                <nz-space nzDirection="horizontal" [nzSize]="8">
                                    <button *nzSpaceItem nz-button nzType="default" nzSize="large" 
                                            (click)="onServiceProviderAccept(0)" [nzLoading]="isLoading"
                                            style="border-color: #52c41a; color: #52c41a;">
                                        <nz-icon nzType="check-circle" nzTheme="outline" /> Accept - No Delay
                                    </button>
                                    <button *nzSpaceItem nz-button nzType="default" nzSize="large" 
                                            (click)="onServiceProviderAccept(15)" [nzLoading]="isLoading"
                                            style="border-color: #52c41a; color: #52c41a;">
                                        <nz-icon nzType="check-circle" nzTheme="outline" /> Accept - 15 min delay
                                    </button>
                                    <button *nzSpaceItem nz-button nzType="default" nzSize="large" 
                                            (click)="onServiceProviderAccept(30)" [nzLoading]="isLoading"
                                            style="border-color: #52c41a; color: #52c41a;">
                                        <nz-icon nzType="check-circle" nzTheme="outline" /> Accept - 30 min delay
                                    </button>
                                    <button *nzSpaceItem nz-button nzType="default" nzSize="large" 
                                            (click)="onServiceProviderAccept(45)" [nzLoading]="isLoading"
                                            style="border-color: #52c41a; color: #52c41a;">
                                        <nz-icon nzType="check-circle" nzTheme="outline" /> Accept - 45 min delay
                                    </button>
                                </nz-space>
                            </div>
                            <div nz-col [nzSpan]="8" style="text-align: right;">
                                <button nz-button nzType="default" nzDanger nzSize="large" 
                                        (click)="onServiceProviderReject()" [nzLoading]="isLoading">
                                    <nz-icon nzType="close-circle" nzTheme="outline" /> Reject Breakdown
                                </button>
                            </div>
                        </div>
                    </nz-card>
                </div>
            </div>
        }
        @if (mustDisplayCallcentreAccept()) {
            <div nz-row [nzJustify]="'center'" style="margin-bottom: 20px;">
                <div nz-col [nzSpan]="20">
                    <nz-alert
                        nzType="warning"
                        nzShowIcon
                        nzMessage="Do you want to accept this breakdown?"
                        nzDescription="This breakdown has been assigned to your callcentre. Please accept or decline it."
                        [nzAction]="callcentreAcceptActions">
                    </nz-alert>
                    <ng-template #callcentreAcceptActions>
                        <nz-space [nzSize]="8">
                            <button *nzSpaceItem nz-button nzType="primary" nzSize="small" [nzLoading]="isLoading" (click)="onCallcentreAccept()">
                                <nz-icon nzType="check-circle" nzTheme="outline" /> Accept
                            </button>
                            <button *nzSpaceItem nz-button nzType="default" nzDanger nzSize="small" [nzLoading]="isLoading" (click)="onCallcentreReject()">
                                <nz-icon nzType="close-circle" nzTheme="outline" /> Decline
                            </button>
                        </nz-space>
                    </ng-template>
                </div>
            </div>
        }
        <div nz-row [nzJustify]="'center'" >
            <div nz-col [nzSpan]="20">
                

                <nz-steps 
                    [nzCurrent]="currentStep" 
                    (nzIndexChange)="onChangeStep($event)" 
                    style="margin-bottom: 25px; background: linear-gradient(to bottom, #fafafa 0%, #ffffff 100%); padding: 20px; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.08);">
                    <nz-step 
                        nzTitle="LOCATION" 
                        nzDescription="Breakdown location"
                            style="cursor: pointer;">
                        </nz-step>
                    @if (this.authService.isClientCallCentre || this.authService.isClientServiceProvider) {
                        <nz-step 
                            nzTitle="BREAKDOWN DETAILS" 
                            nzDescription="Service providers and breakdown details"
                            [nzDisabled]="this.incident.statusId < 1"
                            style="cursor: pointer;">
                        </nz-step>
                        <nz-step 
                            nzTitle="DOCUMENTS" 
                            nzDescription="Upload and manage proof of work and related documents" 
                            [nzDisabled]="this.incident.statusId < 5"
                            style="cursor: pointer;">
                        </nz-step>
                    }
                    @if (this.authService.isClientCallCentre) {
                        <nz-step 
                            nzTitle="ADMINISTRATION" 
                            nzDescription="Purchase orders, invoices and breakdown closure" 
                            [nzDisabled]="this.incident.statusId < 10"
                            style="cursor: pointer;">
                        </nz-step>
                    }
                </nz-steps>
            
                @if (currentStep === 0) { <!-- LOCATION -->
                    <form nz-form>
                        <!-- Full Width Location -->
                        <nz-card  [nzBordered]="true" style="margin-bottom: 20px;">
                            <div nz-row [nzGutter]="8" style="align-items: center; flex-wrap: nowrap; width: 100%; margin-bottom: 12px; justify-content: space-between;">
                                <div nz-col [nzSpan]="3" style="white-space: nowrap;">
                                    <span style="font-weight: bold;">Breakdown Location</span>
                                </div>
                                <div nz-col [nzSpan]="11">
                                    <div style="display: flex; align-items: center;">
                                        <input nz-input nzSize="default" placeholder="Enter location link..." type="text" name="locationLink" [(ngModel)]="locationLink" style="flex: 1; min-width: 0;" />
                                        <button nz-button nzType="default" (click)="onClickDecodeLocationLink()" [nzLoading]="isLoading" style="white-space: nowrap; flex-shrink: 0;">
                                            <nz-icon nzType="environment" nzTheme="outline" /> Decode Link
                                        </button>
                                    </div>
                                </div>
                                <div nz-col [nzSpan]="8">
                                    @if (sharedDataService.savedLocations.length >= 0) {
                                        <div style="display: flex; align-items: center; gap: 8px;">
                                            <label style="white-space: nowrap; font-weight: 500; margin: 0; flex-shrink: 0;">Saved Locations:</label>
                                            <input nz-input nzSize="default" placeholder="Search saved locations..." id="savedLocationSelect" name="savedLocationSelect" type="text" [(ngModel)]="selectedSaveLocationId" [nzAutocomplete]="savedLocationsAutocomplete" (ngModelChange)="onSavedLocationModelChange($event)" style="flex: 1; min-width: 0;" />
                                            <nz-autocomplete #savedLocationsAutocomplete>
                                                @for (item of sharedDataService.savedLocations; track $index) {
                                                    <nz-auto-option [nzValue]="item.savedLocationId" [nzLabel]="item.description">{{item.description}}</nz-auto-option>
                                                }
                                            </nz-autocomplete>
                                        </div>
                                    }
                                </div>
                            </div>

                                <!-- <div nz-col [nzSpan]="16" style="display: flex; align-items: center; gap: 12px;">
                                    @if (incident.driver) {
                                        <label style="white-space: nowrap; font-weight: 500; margin: 0;">Driver's Cellphone Number:</label>

                                        <input nz-input nzSize="default" placeholder="Enter driver's cellphone number" id="driverCellphone" name="driverCellphone" type="text" [(ngModel)]="incident.driver.phoneNumber" style="flex: 1;" />
                                        @if (hasValidDriverCellNumber()) {
                                            
                                                <button nz-button nzType="default" nzBlock (click)="onClickNotifyDriver(1)" [disabled]="!canNotifyDriver" [nz-tooltip]="!canNotifyDriver ? 'Cannot send Whatsapp to Driver' : ''" style="flex: 1;">
                                                    <nz-icon nzType="message" nzTheme="outline" /> Inform Driver
                                                </button>
                                            
                                                <button nz-button nzType="default" nzBlock (click)="onClickNotifyDriver(2)" [disabled]="!canNotifyDriver" [nz-tooltip]="!canNotifyDriver ? 'Cannot send Whatsapp to Driver' : ''" style="flex: 1;">
                                                    <nz-icon nzType="message" nzTheme="outline" /> Ask Location
                                                </button>
                                            
                                        }
                                    }
                                </div> -->

   
   
                            
                            <app-map-select [mapMarkerLocation]="incident.location" (locationSelected)="onMapSelected($event)" style="margin-top: 16px;"></app-map-select>
                            
                            @if (incident.location && incident.location.latitude && incident.location.longitude) {
                                <div style="margin-top: 10px;">
                                    <button nz-button nzType="default" nzSize="small" nzBlock (click)="isSavedLocationNameModalVisible = true">
                                        <nz-icon nzType="save" nzTheme="outline" /> Save location for future use
                                    </button>
                                </div>
                                <nz-divider></nz-divider>
                                <nz-descriptions [nzColumn]="1" nzSize="small">
                                    <nz-descriptions-item nzTitle="Description">{{ incident.location.description }}</nz-descriptions-item>
                                    <nz-descriptions-item nzTitle="Latitude">{{ incident.location.latitude }}</nz-descriptions-item>
                                    <nz-descriptions-item nzTitle="Longitude">{{ incident.location.longitude }}</nz-descriptions-item>
                                </nz-descriptions>
                            }
                        </nz-card>

                        <!-- Save and Continue Button -->
                        <div style="text-align: center; margin-top: 20px;">
                            <button nz-button nzType="primary" nzSize="large" 
                                        (click)="onClickSaveAndContinue()" 
                                        [nzLoading]="isLoading"
                                        [disabled]="isSavingOrAssigning || !incident.location || !incident.location.latitude || !incident.location.longitude">
                                        <nz-icon nzType="check-circle" nzTheme="outline" /> Save & Continue
                                    </button>
                        </div>
                    </form>
                }
                @else if (currentStep === 1) { <!-- BREAKDOWN DETAILS -->
                    <!-- First display the service providers -->
                    @if (incident.statusId >= 1 && getServiceProviders().length > 0 ) {
                        @if (incident.breakdownTechnician && incident.breakdownTechnician.driverId) {
                            
                            <nz-card nzTitle="" [nzBordered]="true" style="margin-bottom: 20px;">
                                <div nz-row [nzGutter]="16">
                                    <div nz-col [nzSpan]="12">
                                        <p><strong><nz-icon nzType="user" nzTheme="outline"></nz-icon> Breakdown Technician:</strong></p>
                                        <p style="font-size: 16px; margin-left: 24px;">{{incident.breakdownTechnician.name}}</p>
                                    </div>
                                    <div nz-col [nzSpan]="12">
                                        <p><strong><nz-icon nzType="mobile" nzTheme="outline"></nz-icon> Contact Number:</strong></p>
                                        <p style="font-size: 16px; margin-left: 24px;">
                                            <a href="tel:{{incident.breakdownTechnician.phoneNumber}}">{{incident.breakdownTechnician.phoneNumber}}</a>
                                        </p>
                                    </div>
                                    <div nz-col [nzSpan]="24">
                                        @if (hasBDTechAcceptedIncident() === true) {
                                            <nz-tag nzColor="success" style="margin-top: 8px; width: fit-content;">
                                                <nz-icon nzType="check-circle" nzTheme="outline"></nz-icon> Accepted
                                            </nz-tag>
                                        }
                                        @if (hasBDTechAcceptedIncident() === false &&  incident.statusId === 6) {
                                            <button nz-button nzType="default" (click)="onClickSendTechRequest(incident.breakdownTechnician.driverId)" style="margin-top: 8px;" [nzLoading]="isLoading">
                                                <nz-icon nzType="exclamation-circle" nzTheme="outline"></nz-icon> Resend Request 
                                            </button>
                                        }
                                        @if (incident.statusId > 4 && incident.statusId < 7 && hasBDTechAcceptedIncident() === false) {
                                            <button nz-button nzType="default" (click)="onClickDriverHasAccepted(incident.breakdownTechnician.driverId)" style="margin-top: 8px;" [nzLoading]="isLoading">
                                                <nz-icon nzType="check-circle" nzTheme="outline"></nz-icon> Technician Accepted 
                                            </button>
                                        }
                                        @if (incident.statusId === 7 ) {
                                            <button nz-button nzType="default" (click)="onClickDriverHasArrived()" style="margin-top: 8px;" [nzLoading]="isLoading">
                                                <nz-icon nzType="check-circle" nzTheme="outline"></nz-icon> Technician Arrived 
                                            </button>
                                        }
                                        <button nz-button nzType="default" (click)="onClickNotifyAllViaWhatsapp()" style="margin-top: 8px; background-color: #25D366; border-color: #25D366; color: #fff;" [nzLoading]="isLoading" nz-tooltip nzTooltipTitle="Notify breakdown technician via WhatsApp">
                                            <nz-icon nzType="whats-app" nzTheme="outline"></nz-icon> Inform Details Update
                                        </button>
                                        
                                    </div>
                                </div>
                            </nz-card>
                            
                        }
                        
                        @else if (canSelectBreakdownTechnician() && hasSelectedServiceProvider() && (!this.incident.breakdownTechnician || !this.incident.breakdownTechnician.driverId)) {
                            @if (amSelectedServiceProvider()) {
                                
                                <nz-alert
                                    nzType="warning"
                                    nzShowIcon
                                    [nzIcon]="iconTemplate"
                                    style="margin-bottom: 20px; border: 2px solid #faad14; border-radius: 8px; animation: pulse 2s infinite;"
                                    nzDescription="Action Required: Select a breakdown technician to proceed with this breakdown">
                                    <ng-template #iconTemplate>
                                        <nz-icon nzType="exclamation-circle" nzTheme="twotone" [nzTwotoneColor]="'#faad14'" style="font-size: 24px;"></nz-icon>
                                    </ng-template>
                                </nz-alert>
                            }
                            
                            <nz-card style="background: linear-gradient(135deg, #fff7e6 0%, #fffbe6 100%); border: 2px solid #ffa940; border-radius: 8px; box-shadow: 0 4px 12px rgba(250, 173, 20, 0.2); margin-bottom: 20px;">
                                <nz-form-item style="margin-bottom: 0;">
                                    <nz-form-label [nzSpan]="24" nzFor="breakdownTechnician" style="font-size: 16px; font-weight: bold; color: #d46b08;">
                                        <nz-icon nzType="user-add" nzTheme="outline" style="font-size: 18px; margin-right: 8px;"></nz-icon>
                                        SELECT BREAKDOWN TECHNICIAN
                                    </nz-form-label>
                                    <nz-form-control [nzSpan]="24" style="margin-top: 12px;">
                                        <nz-select 
                                            id="breakdownTechnician"
                                            nzShowSearch 
                                            nzAllowClear 
                                            nzPlaceHolder="⚠️ Select breakdown technician to continue..." 
                                            [(ngModel)]="incident.breakdownTechnician.driverId" 
                                            (ngModelChange)="onSelectBreakdownTechnician($event)"
                                            nzSize="large"
                                            style="width: 100%; font-size: 16px;">
                                            @for (tech of breakdownTechnicians; track tech.driverId) {
                                                <nz-option [nzValue]="tech.driverId" [nzLabel]="tech.name + ' - ' + tech.phoneNumber + ' (' + this.getTechStatusText(tech.statusId) + ')'" nzCustomContent>
                                                    <span style="display: flex; align-items: center; gap: 8px;">
                                                        @if (tech.statusId === 2) {
                                                            <nz-icon nzType="stop" nzTheme="outline" [style.color]="getTechStatusColor(tech.statusId)"></nz-icon>
                                                        }
                                                        @if (tech.statusId === 3) {
                                                             <nz-icon nzType="clock-circle" nzTheme="outline" [style.color]="getTechStatusColor(tech.statusId)"></nz-icon>
                                                        }
                                                        @if ( tech.statusId === 1 || !tech.statusId) {
                                                            <nz-icon nzType="check-circle" nzTheme="outline" [style.color]="getTechStatusColor(tech.statusId)"></nz-icon>
                                                        }                           
                                                        {{ tech.name }} - {{ tech.phoneNumber }} 
                                                        <span [style.color]="getTechStatusColor(tech.statusId)" style="font-weight: 500;">
                                                            ({{ getTechStatusText(tech.statusId) }})
                                                        </span>
                                                    </span>
                                                </nz-option>
                                            }
                                        </nz-select>
                                    </nz-form-control>
                                </nz-form-item>
                            </nz-card>
                        }
                        
                        <nz-card [nzTitle]="serviceProvidersTitle" [nzBordered]="true" style="margin-bottom: 20px;">
                            <ng-template #serviceProvidersTitle>
                                <div style="display: flex; align-items: center; justify-content: space-between; width: 100%;">
                                    <span style="font-weight: bold;"><nz-icon nzType="team" nzTheme="outline" /> Service Providers</span>
                                    <div style="display: flex; align-items: center; gap: 12px;">
                                        <div style="position: relative;">
                                            <input nz-input
                                                nzSize="small"
                                                placeholder="Add service provider..."
                                                [(ngModel)]="spSearchText"
                                                [nzAutocomplete]="spSearchAutocomplete"
                                                style="width: 240px;" />
                                            <nz-autocomplete #spSearchAutocomplete (selectionChange)="onSelectServiceProviderFromSearch($event)">
                                                @for (sp of getUnlinkedServiceProviders(); track sp.clientId) {
                                                    <nz-auto-option [nzValue]="sp.clientId" [nzLabel]="sp.clientName">
                                                        <span>{{ sp.clientName }}</span>
                                                    </nz-auto-option>
                                                }
                                            </nz-autocomplete>
                                        </div>
                                        <button nz-button nzType="link" (click)="onClickViewSPMap()" [nzLoading]="isLoading" style="padding: 0;">
                                            <nz-icon nzType="environment" nzTheme="outline"></nz-icon> View Map
                                        </button>
                                    </div>
                                </div>
                            </ng-template>
                            
                            @if (hasInactiveServiceProviders() && authService.isClientCallCentre) {
                                <div style="margin-bottom: 16px; padding: 12px; background-color: #f5f5f5; border-radius: 4px;">
                                    <nz-space [nzSize]="8">
                                        <span *nzSpaceItem><nz-icon nzType="eye" nzTheme="outline"></nz-icon></span>
                                        <span *nzSpaceItem style="font-weight: 500;">Show Inactive Service Providers:</span>
                                        <nz-switch
                                            *nzSpaceItem
                                            [(ngModel)]="isShowingInactiveServiceProviders"
                                            [nzCheckedChildren]="checkedTemplate"
                                            [nzUnCheckedChildren]="uncheckedTemplate">
                                        </nz-switch>
                                        <ng-template #checkedTemplate><nz-icon nzType="check" /></ng-template>
                                        <ng-template #uncheckedTemplate><nz-icon nzType="close" /></ng-template>
                                    </nz-space>
                                </div>
                            }
                            
                            <nz-table 
                                #serviceProviderTable 
                                [nzData]="getDisplayServiceProviders()" 
                                [nzShowPagination]="false"
                                [nzBordered]="true">
                            <thead>
                                <tr>
                                    <th><nz-icon nzType="team" nzTheme="outline" />Service Provider</th>
                                    <th nzColumnKey="distance" [nzSortFn]="sortByDistance" nzSortOrder="ascend"><nz-icon nzType="environment" nzTheme="outline" /> Distance</th>
                                    <th nzColumnKey="eta" [nzSortFn]="sortByEta" style="text-align: center;"><nz-icon nzType="clock-circle" nzTheme="outline" /> ETA</th>
                                    <th style="text-align: center;"><nz-icon nzType="dashboard" nzTheme="outline" /> Status</th>
                                    <th style="text-align: center;"><nz-icon nzType="tool" nzTheme="outline" /> Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                
                                @for (item of serviceProviderTable.data; track $index) { 
                                    <tr [class.table-row-inactive]="item.isActive === false">
                                        <td>
                                            <div style="display: flex; flex-direction: column;">
                                                @if (isSpDirectlyLinked(item.clientId)) {
                                                    <span style="font-weight: 500; font-size: 14px;">{{item.clientName}}
                                                        @if (item.whatsappGroupLink) {
                                                            <a (click)="waGroupOpenerLink = item.whatsappGroupLink; waGroupOpenerEtaOverride = item.incidentTravelTimeMinutes; waGroupOpenerIsFleet = false; waGroupOpenerServiceProviderId = item.clientId; isWaGroupOpenerModalVisible = true" style="cursor: pointer; margin-left: 8px;">
                                                                <nz-icon nzType="whats-app" nzTheme="outline" [ngStyle]="{ 'font-size': '18px', 'color': '#25D366' }"></nz-icon>
                                                            </a>
                                                        }
                                                    </span>
                                                    @if (item.clientTel) {
                                                        <span style="color: #8c8c8c; font-size: 12px;">
                                                            <nz-icon nzType="phone" nzTheme="outline"></nz-icon> 
                                                            <a href="tel:{{item.clientTel}}">{{item.clientTel}}</a>
                                                        </span>
                                                    }
                                                    @if (item.canSelectBreakdownTechnician){
                                                        <nz-tag nzColor="success" style="margin-top: 8px; width: fit-content;" >
                                                            Direct to Technician
                                                        </nz-tag>     
                                                    }
                                                    @if (item.canSelectBreakdownTechnician === false){
                                                        <nz-tag nzColor="processing" style="margin-top: 8px; width: fit-content;" >
                                                            SP Controller Selects Technician
                                                        </nz-tag>     
                                                    }
                                                    @if (item.canSelectBreakdownTechnician === null){
                                                        <nz-tag nzColor="processing" style="margin-top: 8px; width: fit-content;" >
                                                            3rd Party SP
                                                        </nz-tag>     
                                                    }
                                                    @if (item.hasSpAccepted) {
                                                        <nz-tag nzColor="success" style="margin-top: 8px; width: fit-content;">
                                                            <nz-icon nzType="check-circle" nzTheme="outline"></nz-icon> Accepted
                                                        </nz-tag>
                                                    }
                                                } @else {
                                                    <span style="font-weight: 500; font-size: 14px;">{{ getSpCallcentreName(item.clientId) }}</span>
                                                    <nz-tag nzColor="warning" style="margin-top: 8px; width: fit-content;">
                                                        <nz-icon nzType="team" nzTheme="outline"></nz-icon> Via Callcentre
                                                    </nz-tag>
                                                }
                                            </div>
                                        </td>
                                        <td>
                                            @if (isBusyLoadingServiceProvider(item.clientId)) {
                                                <nz-spin nzSimple [nzSize]="'small'"></nz-spin>
                                            }
                                            @else if (item.incidentDistance == null) {
                                                <span>Unavailable</span>
                                            }
                                            @else {
                                                <nz-statistic 
                                                    [nzValue]="item.incidentDistance" 
                                                    [nzSuffix]="'km'"
                                                    [nzValueStyle]="{ fontSize: '16px', fontWeight: '500' }">
                                                </nz-statistic>
                                            }
                                        </td>
                                        <td style="text-align: center;">
                                            @if (isBusyLoadingServiceProvider(item.clientId)) {
                                                <nz-spin nzSimple [nzSize]="'small'"></nz-spin>
                                            }
                                            @else if (incident.breakdownTechnicianDriverEta) {
                                                <div style="padding: 8px;">
                                                    <div style="font-weight: 500; font-size: 16px; color: #1890ff;">
                                                        {{incident.breakdownTechnicianDriverEta + 'Z' | date:'HH:mm'}}
                                                    </div>
                                                    <div style="color: #8c8c8c; font-size: 12px; margin-top: 4px;">
                                                        {{ gFuncs.formatMinutesToDuration(gFuncs.calculateMinutes(incident.breakdownTechnicianDriverEta)) }}
                                                    </div>
                                                </div>
                                            }
                                            @else if (item.incidentTravelTimeMinutes == null) {
                                                <span>Unavailable</span>
                                                <button type="button" nz-button nzType="link" nzSize="small"
                                                    nz-tooltip nzTooltipTitle="Recalculate distance and ETA"
                                                    aria-label="Recalculate provider ETA"
                                                    [disabled]="isBusyLoadingServiceProvider(item.clientId)"
                                                    (click)="recalculateProviderEta(item.clientId)">
                                                    <nz-icon nzType="reload" nzTheme="outline" />
                                                </button>
                                            }
                                            @else {
                                                <div style="padding: 8px;">
                                                    <div style="font-weight: 500; font-size: 16px; color: #1890ff;">
                                                        {{ gFuncs.calculateTimeFromMinutes(item.incidentTravelTimeMinutes) | date:'HH:mm' }}
                                                    </div>
                                                    <div style="color: #8c8c8c; font-size: 12px; margin-top: 4px;">
                                                        {{ gFuncs.formatMinutesToDuration(item.incidentTravelTimeMinutes) }}
                                                    </div>
                                                </div>
                                            }
                                        </td>
                                        <td style="text-align: center;">
                                            <!-- LIVE STOCK CHECK -->
                                            @if (isSpDirectlyLinked(item.clientId)) {
                                                @if (!item.activeQuoteId || item.activeQuoteId === 0) {
                                                    
                                                    <nz-tag [nzColor]="'default'" style="min-width: 100px; cursor: not-allowed; opacity: 0.6;">
                                                        @if (isBusyQuotingServiceProvider(item.clientId)) {
                                                            <nz-spin nzSimple />
                                                        }
                                                        @else {
                                                            NO QUOTE<br /><nz-icon nzType="close-circle" nzTheme="outline" style="font-size: 2rem;margin-top: 10px;"/><br />
                                                            <small>Tyre Required</small>
                                                        }
                                                    </nz-tag>
                                                } @else {
                                                    <nz-tag (click)="onClickViewQuote(item.activeQuoteId)" [nzColor]="item.quoteSummary && item.quoteSummary.stockChecked ? 'success' : 'error'" style="min-width: 100px; cursor: pointer;"  nz-popover [nzPopoverContent]="contentTemplate" [nzPopoverTitle]="" nzPopoverPlacement="top">
                                                        LIVE STOCK<br /><nz-icon nzType="check-circle" nzTheme="outline" style="font-size: 2rem;margin-top: 10px;"/><br />              
                                                        @if (item.quoteSummary && item.quoteSummary.stockChecked) {
                                                            <small>{{ gFuncs.formatMinutesToDuration(gFuncs.calculateMinutesSince(item.quoteSummary.stockChecked)) }} ago</small>
                                                        } @else {
                                                           <small> No</small>
                                                        }    
                                                    </nz-tag>
                                                }
                                            }
                                                    <ng-template #contentTemplate>
                                                        <div class="quote-popover">
                                                            @for (option of item.quoteSummary.quoteOptions; track $index) {
                                                                <div class="quote-option-item">
                                                                    <div class="quote-option-details">
                                                                        <div class="option-number">{{ option.optionNumber }}</div>
                                                                        <div class="option-content">
                                                                            <div class="option-name">{{option.name}}</div>
                                                                            @if (option.tyreName && option.tyreName.length > 0) {
                                                                                <div class="option-tyre-info">
                                                                                    <nz-icon nzType="tool" nzTheme="outline"></nz-icon>
                                                                                    {{option.tyreName}}
                                                                                    <span class="stock-badge">SOH: {{option.tyreSoh}}</span>
                                                                                </div>
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                    <div class="quote-option-price">
                                                                        <div class="price-amount">R{{ option.total | number:'1.2-2' }}</div>
                                                                        <div class="price-label">ex vat</div>
                                                                    </div>
                                                                </div>
                                                            }
                                                        </div>
                                                    </ng-template>                                          
                                            <!-- ACCURATE LOCATION -->
                                            <!-- @if (item.hasAccurateLocation) {
                                                <nz-tag nzColor="success" style="min-width: 100px;">LOCATION<br /><nz-icon nzType="pushpin" nzTheme="outline" style="font-size: 2rem;margin-top: 10px;"/><br /><small>Accurate Location</small></nz-tag>
                                            }
                                            @else {
                                                <nz-tag nzColor="warning" style="min-width: 100px;">LOCATION<br /><nz-icon nzType="exclamation-circle" nzTheme="outline" style="font-size: 2rem;margin-top: 10px;"/><br /><small>Approx Location</small></nz-tag>
                                            } -->
                                            <!-- TECHNICIAN STATES -->
                                            @if (item.technicianStatusId === 1){
                                                <nz-tag (click)="onClickTechStatusUpdate(item.clientId)" nzColor="success" style="min-width: 100px; cursor: pointer;" nz-tooltip="Click to request a status update">TECHNICIAN<br /><nz-icon nzType="check-circle" nzTheme="outline" style="font-size: 2rem;margin-top: 10px;"/><br /><small>Driver Ready </small></nz-tag>
                                            }
                                            @else if (item.technicianStatusId > 1) {
                                                <nz-tag (click)="onClickTechStatusUpdate(item.clientId)" nzColor="error" style="min-width: 100px; cursor: pointer;" nz-tooltip="Click to request a status update">TECHNICIAN<br /><nz-icon nzType="exclamation-circle" nzTheme="outline" style="font-size: 2rem;margin-top: 10px;"/><br /><small>Not Ready</small></nz-tag>
                                            }
                                            @else {
                                                <nz-tag (click)="onClickTechStatusUpdate(item.clientId)" nzColor="warning" style="min-width: 100px; cursor: pointer;" nz-tooltip="Click to request a status update">TECHNICIAN<br /><nz-icon nzType="question-circle" nzTheme="outline" style="font-size: 2rem;margin-top: 10px;"/><br /><small>Status Unknown</small></nz-tag>
                                            }
                                        </td>
                                        <td style="text-align: center;">
                                            @if (isBusyLoadingServiceProvider(item.clientId)) {
                                                <nz-spin nzSimple [nzSize]="'small'"></nz-spin>
                                            }
                                            @else {
                                                <nz-space-compact [nzSize]="'large'" nzDirection="vertical" style="width: 100%;" nzBlock>
                                                    @if (incident.statusId < 5) {
                                                        @if (isSpDirectlyLinked(item.clientId)) {
                                                            <button nz-button nzType="primary" (click)="onClickSelectServiceProvider(item)" [nzLoading]="isAssigningServiceProvider" [disabled]="isAssigningServiceProvider">
                                                                <nz-icon nzType="check-circle" nzTheme="outline" /> Assign Provider
                                                            </button>
                                                        } @else {
                                                            @let ccStatus = getCallcentreIsActiveForSp(item.clientId);
                                                            <button nz-button nzType="default" (click)="onClickAssignCallcentre(item.clientId)" [nzLoading]="isLoading" [disabled]="ccStatus === true">
                                                                <nz-icon nzType="team" nzTheme="outline" /> {{ ccStatus === null ? 'Callcentre Asked' : ccStatus === true ? 'Managing' : 'Assign Callcentre' }}
                                                            </button>
                                                        }
                                                    }
                                                    <!-- SP has been assigned, now operator can manually progress status forward -->
                                                    @if (incident.statusId === 5 ) {
                                                        <button nz-button nzType="default" (click)="onClickDriverAsked()" style="margin-top: 8px;" [nzLoading]="isLoading" nz-tooltip="Click to indicate technician has been asked to attend to the incident">
                                                            <nz-icon nzType="check-circle" nzTheme="outline"></nz-icon> Technician Asked 
                                                        </button>
                                                        
                                                        <button nz-button nzType="default" nzDanger (click)="onClickUnassignProvider()" style="margin-top: 8px;" [nzLoading]="isLoading" nz-tooltip="Click to unassign this service provider">
                                                            <nz-icon nzType="close-circle" nzTheme="outline"></nz-icon> Unassign Provider 
                                                        </button>

                                                    }
                                                    @if (incident.statusId === 6 && hasBDTechAcceptedIncident() === false) {
                                                        <button nz-button nzType="default" (click)="onClickDriverHasAccepted()" style="margin-top: 8px;" [nzLoading]="isLoading" nz-tooltip="Click to indicate technician has accepted the incident">
                                                            <nz-icon nzType="check-circle" nzTheme="outline"></nz-icon> Technician Accepted 
                                                        </button>
                                                    }
                                                    @if (incident.statusId === 7 ) {
                                                        <button nz-button nzType="default" (click)="onClickDriverHasArrived()" style="margin-top: 8px;" [nzLoading]="isLoading" nz-tooltip="Click to indicate technician has arrived at the incident">
                                                            <nz-icon nzType="check-circle" nzTheme="outline"></nz-icon> Technician Arrived 
                                                        </button>
                                                    }
                                                    @if (item.isActive === true || item.isActive === null || item.isActive === undefined) {
                                                        <!-- @if (item.activeQuoteId && item.activeQuoteId > 0) {                                                                
                                                            <button nz-button nzType="default" (click)="onClickViewQuote(item.activeQuoteId)" [disabled]="!item.activeQuoteId || item.activeQuoteId === 0"
                                                            >
                                                                <nz-icon nzType="file-text" nzTheme="outline" /> View Quote
                                                            </button>
                                                        } -->
                                                        @if (item.activeQuoteId && item.quoteSummary.statusId === 11) {
                                                            <button nz-button nzType="default" (click)="viewInvoice(item.activeQuoteId)" [disabled]="!item.activeQuoteId || item.activeQuoteId === 0">
                                                                <nz-icon nzType="file-text" nzTheme="outline" /> View Invoice
                                                            </button>
                                                            <button nz-button nzType="default" (click)="onClickGenerateQuoteToFleet(item.activeQuoteId)" [disabled]="!item.activeQuoteId || item.activeQuoteId === 0">
                                                                <nz-icon nzType="file-pdf" nzTheme="outline" /> Quote to Fleet
                                                            </button>
                                                        }
                                                    }
                                                    
                                                </nz-space-compact>


                                            }
                                        </td>
                                    </tr>
                                }
                            </tbody>
                        </nz-table>
                        </nz-card>
                    }
                    
                    @if (getServiceProviders().length % 5 === 0 && incident.statusId < 7) {
                        <div style="text-align: center; margin-bottom: 20px;">
                            <button nz-button nzType="dashed" (click)="load5ServiceProviders()"><nz-icon nzType="plus-circle" nzTheme="outline" /> Load More Service Providers</button>
                        </div>
                    }

                    <!-- Breakdown Details -->
                    <form nz-form>
                        <ng-template #breakdownDetailsTitle>
                            <div class="breakdown-details-title">
                                <span>Breakdown Details</span>
                                <span class="required-progress">{{ incident.populatedMinimumRequiredFieldsText }}</span>
                            </div>
                        </ng-template>
                        <nz-card [nzTitle]="breakdownDetailsTitle" [nzBordered]="true" style="margin-bottom: 20px;">
                            <div nz-row [nzGutter]="24" style="align-items: stretch;">

                                <!-- Column 1: Form Fields -->
                                <div nz-col [nzSpan]="12">

                                    <!-- Vehicle -->
                                    <nz-form-item>
                                        <nz-form-label [nzSpan]="6" nzFor="vehicleReg">Vehicle</nz-form-label>
                                        <nz-form-control [nzSpan]="18" nzHasFeedback [nzValidateStatus]="isLoadingFleetVehicles ? 'validating' : ''" [appValidationBorder]="incident.fleetVehicle.registrationNumber">
                                            <input nz-input
                                                nzSize="default"
                                                placeholder="Registration or Fleet number"
                                                id="vehicleReg"
                                                name="vehicleReg"
                                                type="text"
                                                [(ngModel)]="incident.fleetVehicle.registrationNumber"
                                                [ngModelOptions]="{standalone: true}"
                                                [nzAutocomplete]="vehicleAutocomplete"
                                                (input)="onVehicleRegInput($event)"
                                                style="width: 100%;" />
                                            <nz-autocomplete #vehicleAutocomplete (selectionChange)="onSelectVehicleFromAutocomplete($event)">
                                                @for (item of fleetVehicles; track $index) {
                                                    <nz-auto-option [nzValue]="item.registrationNumber" [nzLabel]="item.registrationNumber">
                                                        {{ item.registrationNumber }}
                                                    </nz-auto-option>
                                                }
                                            </nz-autocomplete>
                                        </nz-form-control>
                                    </nz-form-item>

                                    <!-- Transporter -->
                                    @if (isFleetLinkedToLoggedInClient() || incident.clientId === null || incident.clientId === undefined || incident.clientId === 0) {
                                        <nz-form-item>
                                            <nz-form-label [nzSpan]="6" nzFor="fleet">Fleet Controller</nz-form-label>
                                            <nz-form-control [nzSpan]="16">
                                                <nz-select 
                                                    id="fleet"
                                                    nzShowSearch 
                                                    nzAllowClear 
                                                    nzPlaceHolder="Search For Fleet Controller..." 
                                                    [(ngModel)]="incident.clientId"
                                                    [ngModelOptions]="{standalone: true}"
                                                    (ngModelChange)="onSelectFleetById($event)"
                                                    (nzOnSearch)="onFleetSearchChange($event)"
                                                    style="width: 100%;">
                                                    @for (fleet of sharedDataService.getFleets; track fleet.clientId) {
                                                        <nz-option [nzValue]="fleet.clientId" [nzLabel]="fleet.clientName"></nz-option>
                                                    }
                                                </nz-select>
                                            </nz-form-control>
                                            <nz-form-control [nzSpan]="2" style="display: flex; align-items: center;">
                                                @if (!incident.clientId) {
                                                    <button nz-button nzSize="small" (click)="onAddNewFleet()"
                                                        style="width: 28px; height: 28px; padding: 0; display: flex; align-items: center; justify-content: center;"
                                                        nz-tooltip nzTooltipTitle="Add new Fleet Controller">
                                                        <nz-icon nzType="plus-circle" nzTheme="outline" />
                                                    </button>
                                                } @else {
                                                    <button nz-button nzSize="small" nzType="default"
                                                        style="width: 28px; height: 28px; padding: 0; display: flex; align-items: center; justify-content: center;"
                                                        [disabled]="!incident.clientWhatsappGroupLink"
                                                        [style.background-color]="incident.clientWhatsappGroupLink ? '#25D366' : ''"
                                                        [style.border-color]="incident.clientWhatsappGroupLink ? '#25D366' : ''"
                                                        [style.color]="incident.clientWhatsappGroupLink ? '#fff' : ''"
                                                        (click)="waGroupOpenerLink = incident.clientWhatsappGroupLink!; waGroupOpenerEtaOverride = null; waGroupOpenerIsFleet = true; waGroupOpenerServiceProviderId = null; isWaGroupOpenerModalVisible = true"
                                                        nz-tooltip nzTooltipTitle="Fleet WhatsApp Group">
                                                        <nz-icon nzType="whats-app" nzTheme="outline" />
                                                    </button>
                                                }
                                            </nz-form-control>
                                        </nz-form-item>
                                        <nz-form-item>
                                            <nz-form-label [nzSpan]="6" nzFor="transporterName">Transporter</nz-form-label>
                                            <nz-form-control [nzSpan]="18" [appValidationBorder]="incident.transporterName">
                                                <input
                                                    nz-input
                                                    id="transporterName"
                                                    name="transporterName"
                                                    placeholder="Enter transporter name"
                                                    [ngModel]="incident.transporterName"
                                                    (ngModelChange)="onTransporterInput($event)"
                                                    [ngModelOptions]="{standalone: true}"
                                                    [nzAutocomplete]="transporterAuto"
                                                    style="width: 100%;" />
                                                <nz-autocomplete #transporterAuto>
                                                    @for (name of filteredTransporters; track name) {
                                                        <nz-auto-option [nzValue]="name">{{ name }}</nz-auto-option>
                                                    }
                                                </nz-autocomplete>
                                            </nz-form-control>
                                        </nz-form-item>
                                    } @else {
                                        <nz-form-item>
                                            <nz-form-label [nzSpan]="6">Fleet Controller</nz-form-label>
                                            <nz-form-control [nzSpan]="18">
                                                <span>{{ incident.clientName }}</span>
                                            </nz-form-control>
                                        </nz-form-item>
                                        <nz-form-item>
                                            <nz-form-label [nzSpan]="6">Transporter</nz-form-label>
                                            <nz-form-control [nzSpan]="18" [appValidationBorder]="incident.transporterName">
                                                <span>{{ incident.transporterName }}</span>
                                            </nz-form-control>
                                        </nz-form-item>
                                        @let otherCC = getOtherMainCallcentre(incident);
                                        @if (otherCC) {
                                            <nz-form-item>
                                                <nz-form-label [nzSpan]="6">Call Centre</nz-form-label>
                                                <nz-form-control [nzSpan]="18">
                                                    @if (otherCC.whatsappGroupLink) {
                                                        <a (click)="waGroupOpenerLink = otherCC.whatsappGroupLink; waGroupOpenerEtaOverride = null; waGroupOpenerIsFleet = false; waGroupOpenerServiceProviderId = null; isWaGroupOpenerModalVisible = true" style="cursor: pointer;">
                                                            <small style="color: black; margin-right: 8px;">Via: {{ otherCC.clientName }}</small> <br />
                                                            <nz-icon nzType="whats-app" nzTheme="outline" [ngStyle]="{ 'font-size': '18px', 'color': '#25D366' }"></nz-icon>
                                                            {{ otherCC.whatsappGroupName ? otherCC.whatsappGroupName : '' }}
                                                        </a>
                                                    } @else {
                                                        <small>Via: {{ otherCC.clientName }}</small>
                                                    }
                                                </nz-form-control>
                                            </nz-form-item>
                                        }
                                    }

                                    <!-- Driver Cell -->
                                    <nz-form-item>
                                        <nz-form-label [nzSpan]="6" nzFor="driverCell">Driver Cell</nz-form-label>
                                        <nz-form-control [nzSpan]="18" [appValidationBorder]="incident.driver.phoneNumber">
                                            <div style="display: flex; align-items: center; gap: 8px; flex-wrap: wrap;">
                                                <div style="flex: 1; min-width: 150px; position: relative;">
                                                    <input nz-input 
                                                        nzSize="default" 
                                                        placeholder="Driver phone number" 
                                                        id="driverCell" 
                                                        name="driverCell" 
                                                        type="text" 
                                                        [(ngModel)]="incident.driver.phoneNumber" 
                                                        [nzAutocomplete]="driverAutocomplete"
                                                        (blur)="onDriverCellBlur()"
                                                        style="width: 100%;" />
                                                    <nz-autocomplete #driverAutocomplete (selectionChange)="onSelectDriverFromAutocomplete($event)">
                                                        @for (item of truckDrivers; track $index) {
                                                            <nz-auto-option [nzValue]="item.phoneNumber" [nzLabel]="item.phoneNumber">
                                                                <div style="display: flex; justify-content: space-between; width:350px;">
                                                                    <span><strong>{{item.name}}</strong></span>
                                                                    <span style="color: #8c8c8c;">{{item.phoneNumber}}</span>
                                                                </div>
                                                            </nz-auto-option>
                                                        }
                                                    </nz-autocomplete>
                                                </div>
                                        @if (incident.incidentId && incident.incidentId > 0) {
                                                    <!-- <button nz-button nzType="default" (click)="onClickNotifyDriver(1)" [disabled]="!hasValidDriverCellNumber()" [nz-tooltip]="!hasValidDriverCellNumber() ? 'Please enter a valid driver phone number (10 digits starting with 0)' : ''">
                                                        <nz-icon nzType="message" nzTheme="outline" /> Inform Driver
                                                    </button> -->
                                                    <button nz-button nzType="default" (click)="onClickAskDriverLocation()" [disabled]="!hasValidDriverCellNumber()" [nz-tooltip]="!hasValidDriverCellNumber() ? 'Please enter a valid driver phone number (10 digits starting with 0)' : ''">
                                                        <nz-icon nzType="message" nzTheme="outline" /> Ask Location
                                                    </button>
                                                }
                                            </div>
                                        </nz-form-control>
                                    </nz-form-item>

                                    <!-- Driver Name -->
                                    <nz-form-item>
                                        <nz-form-label [nzSpan]="6" nzFor="driverName">Driver Name</nz-form-label>
                                        <nz-form-control [nzSpan]="18" [appValidationBorder]="incident.driver.name" [validationBorderRequired]="false">
                                            <input nz-input 
                                                nzSize="default" 
                                                placeholder="Driver name" 
                                                id="driverName" 
                                                name="driverName" 
                                                type="text" 
                                                [(ngModel)]="incident.driver.name"
                                                style="width: 100%;" />
                                        </nz-form-control>
                                    </nz-form-item>

                                    @if (incident.incidentId && incident.incidentId > 0) {

                                        <!-- Tyre Position -->
                                        <nz-form-item>
                                            <nz-form-label [nzSpan]="6">Tyre Position</nz-form-label>
                                            <nz-form-control [nzSpan]="18" [appValidationBorder]="hasSelectedTyreLocation()">
                                                <div style="display: flex; flex-wrap: wrap; gap: 0; width: 100%;">
                                                    <button nz-button [nzSize]="'default'" style="flex: 1;"
                                                        [nzType]="hasTyreInLocation(tyreLocation.steer) ? 'primary' : 'default'" 
                                                        (click)="onClickTyreLocation(tyreLocation.steer)">
                                                        <nz-icon nzType="car" nzTheme="outline" /> Steer
                                                    </button>
                                                    <button nz-button [nzSize]="'default'" style="flex: 1;"
                                                        [nzType]="hasTyreInLocation(tyreLocation.drive) ? 'primary' : 'default'" 
                                                        (click)="onClickTyreLocation(tyreLocation.drive)">
                                                        <nz-icon nzType="build" nzTheme="outline" /> Drive
                                                    </button>
                                                    <button nz-button [nzSize]="'default'" style="flex: 1;"
                                                        [nzType]="hasTyreInLocation(tyreLocation.trailer) ? 'primary' : 'default'" 
                                                        (click)="onClickTyreLocation(tyreLocation.trailer)">
                                                        <nz-icon nzType="block" nzTheme="outline" /> Trailer
                                                    </button>
                                                </div>
                                            </nz-form-control>
                                        </nz-form-item>

                                        <!-- Tyre Type -->
                                        <nz-form-item>
                                            <nz-form-label [nzSpan]="6">Tyre Type</nz-form-label>
                                            <nz-form-control [nzSpan]="18" [appValidationBorder]="hasSelectedTyreType()">
                                                <div style="display: flex; flex-wrap: wrap; gap: 0; width: 100%;">
                                                    <button nz-button style="flex: 1;" [nzType]="isTyreTypeSelected(-1) ? 'primary' : 'default'" (click)="onSelectTyreType(-1)">Import</button>
                                                    <button nz-button style="flex: 1;" [nzType]="isTyreTypeSelected(-2) ? 'primary' : 'default'" (click)="onSelectTyreType(-2)">Retread</button>
                                                    <button nz-button style="flex: 1;" [nzType]="isTyreTypeSelected(-4) ? 'primary' : 'default'" (click)="onSelectTyreType(-4)">Local</button>
                                                    <button nz-button style="flex: 1;" [nzType]="isTyreTypeSelected(-3) ? 'primary' : 'default'" (click)="onSelectTyreType(-3)">Any</button>
                                                    <button nz-button style="flex: 1;" [nzType]="isTyreTypeSelected(-5) ? 'primary' : 'default'" (click)="onSelectTyreType(-5)">Spare</button>
                                                    <button nz-button style="flex: 1;" [nzType]="isTyreTypeSelected(-6) ? 'primary' : 'default'" (click)="onSelectTyreType(-6)">Own Stock</button>
                                                </div>
                                                <!-- Specific Brands dropdown (kept for reference)
                                                <nz-select [nzMaxTagCount]="3" [nzMaxTagPlaceholder]="tyresTagOverflow" nzMode="multiple" nzAllowClear nzPlaceHolder="Specific Brands"
                                                        [(ngModel)]="incident.tyreBrands" [ngModelOptions]="{standalone: true}" style="max-width: 200px; display: inline-block;">
                                                    @for (item of sharedDataService.premiumTyreBrands; track $index) {
                                                        <nz-option [nzLabel]="item.brandName" [nzValue]="item.tyreBrandId"></nz-option>
                                                    }
                                                </nz-select>
                                                <ng-template #tyresTagOverflow let-selectedList>{{ selectedList.length }} more...</ng-template>
                                                -->
                                            </nz-form-control>
                                        </nz-form-item>

                                        <!-- Tyre Size & Qty -->
                                        @if (incident.tyrePositions.length > 0) {
                                            <app-incident-tyre [incidentTyre]="incident.tyrePositions[0]"></app-incident-tyre>
                                        }

                                    }

                                    <!-- Handled By -->
                                    <nz-form-item>
                                        <nz-form-label [nzSpan]="6" nzFor="callcentreOperator">Handled By</nz-form-label>
                                        <nz-form-control [nzSpan]="18">
                                            <nz-select
                                                id="callcentreOperator"
                                                nzShowSearch
                                                nzAllowClear
                                                nzPlaceHolder="Select call centre operator"
                                                [(ngModel)]="incident.callcentreOperatorId"
                                                [ngModelOptions]="{standalone: true}"
                                                style="width: 100%;">
                                                @for (operator of incident.availableCallcentreOperators; track operator.userId) {
                                                    <nz-option
                                                        [nzValue]="operator.userId"
                                                        [nzLabel]="operator.fullName">
                                                    </nz-option>
                                                }
                                            </nz-select>
                                        </nz-form-control>
                                    </nz-form-item>
                                </div>

                                <!-- Column 2: Breakdown Description -->
                                <div nz-col [nzSpan]="12">
                                    @if (incident.incidentId && incident.incidentId > 0) {
                                        <div style="display: flex; flex-direction: column; height: 100%;">
                                            <div nz-row nzJustify="space-between" style="align-items: center; margin-bottom: 12px;">
                                                <label for="incidentDescription" style="font-weight: 500;">Breakdown Description</label>
                                                <button nz-button nzType="primary" (click)="extractDetails()">Extract Details</button>
                                            </div>  
                                            <textarea nz-input id="incidentDescription" name="incidentDescription" [(ngModel)]="incident.incidentDescription"
                                                [appValidationBorder]="incident.incidentDescription"
                                                [ngModelOptions]="{standalone: true}"
                                                style="flex: 1; min-height: 300px; resize: vertical;"></textarea>
                                        </div>
                                    }
                                </div>

                            </div>

                            @if (incident.incidentId && incident.incidentId > 0) {
                                <nz-divider></nz-divider>
                                <nz-form-item nz-row>
                                    <nz-form-control [nzSpan]="24" style="text-align: center;">
                                        @if (this.incident.location === undefined || !this.incident.location.latitude || !this.incident.location.longitude) {
                                            <button nz-button nzType="primary" nzSize="large" (click)="onClickUpdateAndRegisterBreakdown()" [nzLoading]="isLoading" [disabled]="isSavingOrAssigning">
                                                <nz-icon nzType="check-circle" nzTheme="outline" /> Save Breakdown as Draft
                                            </button>
                                        } @else {
                                            <button nz-button nzType="primary" nzSize="large" (click)="onClickUpdateAndRegisterBreakdown()" [nzLoading]="isLoading"
                                                [disabled]="isSavingOrAssigning || this.incident.location === undefined || !this.incident.location.latitude || !this.incident.location.longitude">
                                                <nz-icon nzType="check-circle" nzTheme="outline" /> Update Breakdown Details
                                            </button>
                                        }
                                    </nz-form-control>
                                </nz-form-item>
                            }
                        </nz-card>
                    </form>

                    <!-- Service Providers Section -->
                    @if (getCallCentre() !== undefined && incident.statusId >= 1 && getCallCentre()!.clientId > 0 && !authService.isClientCallCentre) {
                    
                        <nz-card nzTitle="" [nzBordered]="true" style="margin-bottom: 20px;">
                            <div nz-row [nzGutter]="16">
                                <div nz-col [nzSpan]="12">
                                    <p><strong><nz-icon nzType="phone" nzTheme="outline"></nz-icon> Call Centre:</strong></p>
                                    <p style="font-size: 16px; margin-left: 24px;">{{getCallCentre()?.clientName}}</p>
                                </div>
                                <div nz-col [nzSpan]="12">
                                    <p><strong><nz-icon nzType="mobile" nzTheme="outline"></nz-icon> Contact Number:</strong></p>
                                    <p style="font-size: 16px; margin-left: 24px;">
                                        <a href="tel:{{getCallCentre()?.clientTel}}">{{getCallCentre()?.clientTel}}</a>
                                    </p>
                                </div>
                                <!-- <div nz-col [nzSpan]="8">
                                    <p><strong><nz-icon nzType="environment" nzTheme="outline"></nz-icon> Location:</strong></p>
                                    <p style="font-size: 14px; margin-left: 24px;">
                                        Lat: {{getCallCentre()?.latitude | number:'1.4-4'}}, Lng: {{getCallCentre()?.longitude | number:'1.4-4'}}
                                    </p>
                                </div> -->
                            </div>
                        </nz-card>
                        
                    }

                    

                    
                }
                @else if (currentStep === 2) { <!-- DOCUMENTS -->
                    
                    <div style="display: flex; gap: 12px; margin-bottom: 16px; flex-wrap: wrap; align-items: center;">
                        <button nz-button nzType="primary" (click)="isUploadModalVisible = true">
                            <nz-icon nzType="upload" nzTheme="outline" /> Upload Files
                        </button>
                        @if (incident.statusId >= 6 && incident.statusId <= 10) {
                            <button nz-button nzType="primary" (click)="isCompleteWithoutWorkReportConfirmModalVisible = true"
                                style="background-color: #52c41a; border-color: #52c41a;"
                                nz-tooltip nzTooltipTitle="Complete the incident without selecting a work report">
                                <nz-icon nzType="check-circle" nzTheme="outline" /> Complete Incident
                            </button>
                        }
                    </div>
                     @if (incident.statusId >= 5) {                   
                            
                            
                        <div nz-row [nzGutter]="[16, 16]" class="document-gallery">

                            @for (item of visibleDocuments; track item.documentId) {
                                <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="6" [nzXl]="4" [nzXXl]="4">
                                    <app-incident-document-tile [document]="item" [incidentStatusId]="incident.statusId"
                                        (assignWorkReport)="onClickAssignWorkReport($event)" [incidentId]="incident.incidentId"
                                        [canRemove]="item.documentClassificationId !== 2 && (authService.isClientCallCentre || authService.isClientServiceProvider)"
                                        (documentRemoved)="onDocumentRemoved($event)"
                                        ></app-incident-document-tile>
                                        
                                </div>
                            }
                        </div>    
                            
                        
                    }
                }
                @else if (currentStep === 3) { <!-- ADMIN DOCS -->
                    <div nz-row [nzGutter]="16">
                        <div nz-col [nzSpan]="24">
                            <nz-card nzTitle="Administration & Documentation" [nzExtra]="extraTemplate">
                                <nz-descriptions nzBordered [nzColumn]="1">
                                    <nz-descriptions-item nzTitle="Proof of Work">
                                        <button nz-button nzType="primary" (click)="onClickProofOfWork(incident.incidentId)" [nzLoading]="isLoadingProofOfWork">
                                            <nz-icon nzType="file-text" nzTheme="outline" /> View POW
                                        </button>
                                        <button nz-button nzType="default" (click)="onClickSendPOWViaWhatsapp()" style="margin-left: 8px; background-color: #25D366; border-color: #25D366; color: #fff;" nz-tooltip nzTooltipTitle="Send Proof of Work via WhatsApp">
                                            <nz-icon nzType="whats-app" nzTheme="outline"></nz-icon> Send POW
                                        </button>
                                    </nz-descriptions-item>
                                    <nz-descriptions-item nzTitle="Service Provider Quote">
                                        <button nz-button nzType="primary" (click)="onClickGoToServiceProviderQuote()">
                                            <nz-icon nzType="file-text" nzTheme="outline" /> View/Edit Quote
                                        </button>
                                    </nz-descriptions-item>
                                    @if (this.incident.statusId >= 15 && authService.isClientCallCentre) {
                                        <nz-descriptions-item nzTitle="Fleet Quote">
                                            <button nz-button nzType="default" (click)="onClickGenerateQuoteToFleet(getAssignedServiceProviderQuoteId())" 
                                                    [disabled]="!getAssignedServiceProviderQuoteId() || getAssignedServiceProviderQuoteId() === 0">
                                                <nz-icon nzType="file-text" nzTheme="outline" /> Generate Quote for Fleet
                                            </button>
                                            <nz-tag *ngIf="getAssignedServiceProviderQuoteId()" nzColor="success" style="margin-left: 8px;">
                                                Quote Available
                                            </nz-tag>
                                        </nz-descriptions-item>
                                        <nz-descriptions-item nzTitle="Close Incident">
                                            <button nz-button nzType="default" (click)="onClickCloseIncident()">
                                                <nz-icon nzType="file-text" nzTheme="outline" /> Close Incident
                                            </button>
                                            
                                        </nz-descriptions-item>
                                    }
                                </nz-descriptions>
                                <ng-template #extraTemplate>
                                    <nz-tag [nzColor]="incident.statusId >= 12 ? 'success' : 'processing'">
                                        Status: {{ incident.statusId === 12 ? 'Ready for Fleet Quote' : incident.statusId >= 12 ? 'Completed' : 'In Progress' }}
                                    </nz-tag>
                                </ng-template>
                            </nz-card>
                        </div>
                    </div>
                    
                }
            
                
            </div>
            @if (sharedDataService.selectedMessages && sharedDataService.selectedMessages.length > 0) {

                <div nz-col [nzSpan]="4" class="messages-container">
                    <h2>MESSAGES</h2>
                    <div class="messages-list">
                        @for (msg of sharedDataService.selectedMessages; track $index) {
                            <div class="message-bubble incoming">
                                <p class="message-text">{{ msg.message }}</p>
                            </div>
                        }
                    </div>
                </div>
            }
        </div>
        
    </nz-spin>

</div>



<nz-dropdown-menu #otherTyresDropDown="nzDropdownMenu">
      <ul nz-menu>
        @for (item of sharedDataService.tyreBrands; track $index) {
          <li nz-menu-item (click)="onSelectTyreType(item.tyreBrandId, item.brandName)">
            <a>{{ item.brandName }}</a>
          </li>
        }
      </ul>
</nz-dropdown-menu>

<nz-dropdown-menu #knownLocationDropdown="nzDropdownMenu">
      <ul nz-menu>
        <li nz-menu-item>
          <a>N1 City Engen</a>
        </li>
        <li nz-menu-item>
          <a>Kroonstad Shell</a>
        </li>
        <li nz-menu-item>
          <a>Colesberg 1-stop</a>
        </li>
      </ul>
</nz-dropdown-menu>

<nz-dropdown-menu #truckTypes="nzDropdownMenu">
      <ul nz-menu>
        <li nz-menu-item>
          <a>Flatbed</a>
        </li>
        <li nz-menu-item>
          <a>Drop-side</a>
        </li>
        <li nz-menu-item>
          <a>Roadtrain</a>
        </li>
      </ul>
</nz-dropdown-menu>

<nz-dropdown-menu #fleets="nzDropdownMenu">
      <ul nz-menu>
        @for (item of sharedDataService.getFleets; track $index) {
          <li nz-menu-item (click)="onSelectFleet(item)">
            <a>{{ item.clientName }}</a>
          </li>
        }
      </ul>
</nz-dropdown-menu>

<nz-dropdown-menu #openIncidents="nzDropdownMenu">
      <ul nz-menu>
        
        <li nz-menu-item>
        <a>NEW BREAKDOWN</a>
        </li>
        
      </ul>
</nz-dropdown-menu>

<nz-dropdown-menu #pricingTemplates="nzDropdownMenu">
      <ul nz-menu>
        
        @for (item of sharedDataService.priceTemplates; track $index) {
          <li nz-menu-item (click)="onSelectFleetPricing(item)">
            <a>{{ item.pricingName }}</a>
          </li>
        }
      </ul>
</nz-dropdown-menu>

<nz-modal [(nzVisible)]="isSavedLocationNameModalVisible" nzTitle="Save Location Details" (nzOnCancel)="isSavedLocationNameModalVisible = false" (nzOnOk)="onClickSaveLocation()">
    <ng-container *nzModalContent>
    <nz-form-item>
        <nz-form-label [nzSpan]="4" nzFor="savedLocationDescription">Description</nz-form-label>
        <nz-form-control>
            <input nz-input placeholder="Location Description" id="savedLocationDescription" name="savedLocationDescription" type="text" [(ngModel)]="savedLocation.description" />
        </nz-form-control>
    </nz-form-item>
    </ng-container>
</nz-modal>

<nz-modal 
    [(nzVisible)]="isCancelIncidentModalVisible" 
    nzTitle="Cancel Breakdown" 
    (nzOnCancel)="isCancelIncidentModalVisible = false" 
    (nzOnOk)="onConfirmCancelIncident()"
    nzOkText="Yes, Cancel breakdown"
    nzCancelText="No, Keep breakdown"
    nzOkDanger="true"
    nzWidth="500px">
    <ng-container *nzModalContent>
        <p><strong>Are you sure you want to cancel this breakdown?</strong></p>
        <p>This action will mark the breakdown as cancelled and cannot be undone.</p>
        <form nz-form>
            <nz-form-item>
                <nz-form-label [nzSpan]="8" nzFor="cancelReason" nzRequired>Cancel Reason</nz-form-label>
                <nz-form-control [nzSpan]="16">
                    <nz-select id="cancelReason" name="cancelReason" [(ngModel)]="selectedCancelReasonId" nzPlaceHolder="Select a reason">
                        @for (reason of sharedDataService.cancelReasons; track reason.id) {
                            <nz-option [nzValue]="reason.id" [nzLabel]="reason.value"></nz-option>
                        }
                    </nz-select>
                </nz-form-control>
            </nz-form-item>
        </form>
    </ng-container>
</nz-modal>

<nz-modal 
    [(nzVisible)]="isAddDriverModalVisible" 
    nzTitle="Add New Driver" 
    (nzOnCancel)="isAddDriverModalVisible = false" 
    (nzOnOk)="onConfirmAddDriver()"
    nzOkText="Add Driver"
    nzCancelText="Cancel"
    [nzOkLoading]="isLoading">
    <ng-container *nzModalContent>
        <form nz-form>
            <nz-form-item>
                <nz-form-label [nzSpan]="6" nzFor="newDriverName" nzRequired>Driver Name</nz-form-label>
                <nz-form-control [nzSpan]="18">
                    <input nz-input placeholder="Enter driver name" id="newDriverName" name="newDriverName" type="text" [(ngModel)]="incident.driver.name" />
                </nz-form-control>
            </nz-form-item>
            <nz-form-item>
                <nz-form-label [nzSpan]="6" nzFor="newDriverPhone" nzRequired>Phone Number</nz-form-label>
                <nz-form-control [nzSpan]="18">
                    <input nz-input placeholder="Enter phone number" id="newDriverPhone" name="newDriverPhone" type="text" [(ngModel)]="incident.driver.phoneNumber" />
                </nz-form-control>
            </nz-form-item>
        </form>
    </ng-container>
</nz-modal>

<nz-modal 
    [(nzVisible)]="isAddVehicleModalVisible" 
    nzTitle="Add New Vehicle" 
    (nzOnCancel)="isAddVehicleModalVisible = false" 
    (nzOnOk)="onConfirmAddVehicle()"
    nzOkText="Add Vehicle"
    nzCancelText="Cancel"
    [nzOkLoading]="isLoading">
    <ng-container *nzModalContent>
        <form nz-form>
            <nz-form-item>
                <nz-form-label [nzSpan]="8" nzFor="newVehicleReg" nzRequired>Registration Number</nz-form-label>
                <nz-form-control [nzSpan]="16">
                    <input nz-input placeholder="Enter registration number" id="newVehicleReg" name="newVehicleReg" type="text" [(ngModel)]="incident.fleetVehicle.registrationNumber" />
                </nz-form-control>
            </nz-form-item>
            <nz-form-item>
                <nz-form-label [nzSpan]="8" nzFor="newVehicleVin">VIN Number</nz-form-label>
                <nz-form-control [nzSpan]="16">
                    <input nz-input placeholder="Enter VIN number" id="newVehicleVin" name="newVehicleVin" type="text" [(ngModel)]="incident.fleetVehicle.vinNumber" />
                </nz-form-control>
            </nz-form-item>
        </form>
    </ng-container>
</nz-modal>

<nz-modal 
    [(nzVisible)]="isAddFleetModalVisible" 
    nzTitle="Add Fleet Controller" 
    (nzOnCancel)="isAddFleetModalVisible = false" 
    (nzOnOk)="onConfirmAddFleet()"
    nzOkText="Add Fleet Controller"
    nzCancelText="Cancel"
    [nzOkLoading]="isLoading">
    <ng-container *nzModalContent>
        <form nz-form>
            <nz-form-item>
                <nz-form-label [nzSpan]="8" nzFor="newFleetName" nzRequired>Fleet Controller Name</nz-form-label>
                <nz-form-control [nzSpan]="16">
                    <input nz-input placeholder="Enter fleet controller name" id="newFleetName" name="newFleetName" type="text" [(ngModel)]="fleetClient.clientName" />
                </nz-form-control>
            </nz-form-item>
            <nz-form-item>
                <nz-form-label [nzSpan]="8" nzFor="newFleetWaLink">WhatsApp Group Link</nz-form-label>
                <nz-form-control [nzSpan]="16">
                    <input nz-input placeholder="Enter WhatsApp group link" id="newFleetWaLink" name="newFleetWaLink" type="text"
                        [(ngModel)]="fleetClient.whatsappGroupLink"
                        appWaGroupLink
                        (groupNameResolved)="onFleetGroupNameResolved($event)"
                        (loadingChange)="isLoadingFleetGroupName = $event" />
                </nz-form-control>
            </nz-form-item>
            <nz-form-item>
                <nz-form-label [nzSpan]="8" nzFor="newFleetWaGroupName">WhatsApp Group Name</nz-form-label>
                <nz-form-control [nzSpan]="16">
                    <ng-template #fleetGroupNameLoadingSuffix>
                        @if (isLoadingFleetGroupName) {
                            <nz-icon nzType="loading"></nz-icon>
                        }
                    </ng-template>
                    <nz-input-group [nzSuffix]="fleetGroupNameLoadingSuffix">
                        <input nz-input placeholder="Group name (auto-filled from link)" id="newFleetWaGroupName" name="newFleetWaGroupName" type="text" [(ngModel)]="fleetClient.whatsappGroupName" [disabled]="isLoadingFleetGroupName" />
                    </nz-input-group>
                </nz-form-control>
            </nz-form-item>
        </form>
    </ng-container>
</nz-modal>

<app-incident-close-modal 
    [(visible)]="isCloseIncidentModalVisible" 
    [incidentId]="incident.incidentId"
    [orderNumber]="incident.orderNumber"
    (incidentClosed)="onIncidentClosed()">
</app-incident-close-modal>

<nz-modal [(nzVisible)]="isUploadModalVisible" nzTitle="Upload File" (nzOnCancel)="isUploadModalVisible = false"
  (nzOnOk)="handleUploadOk()">
  <ng-container *nzModalContent>
    <app-file-uploader [incidentId]="incident.incidentId" (uploadComplete)="onUploadComplete($event)"></app-file-uploader>
  </ng-container>
</nz-modal>

<nz-drawer
    [nzClosable]="true"
    [nzVisible]="isDelayDrawerVisible"
    [nzPlacement]="'right'"
    nzTitle="Log Delay - Update ETA"
    (nzOnClose)="isDelayDrawerVisible = false"
    [nzHeight]="'auto'">
    
    <ng-container *nzDrawerContent>
        <div style="padding: 16px;">
            <div style="margin-bottom: 20px;">
                <h4>Quick Select</h4>
                <nz-space nzDirection="horizontal" [nzWrap]="true">
                    <button *nzSpaceItem nz-button nzSize="large" (click)="selectDelayMinutes(15)">
                        +15 min
                    </button>
                    <button *nzSpaceItem nz-button nzSize="large" (click)="selectDelayMinutes(30)">
                        +30 min
                    </button>
                    <button *nzSpaceItem nz-button nzSize="large" (click)="selectDelayMinutes(45)">
                        +45 min
                    </button>
                    <button *nzSpaceItem nz-button nzSize="large" (click)="selectDelayMinutes(60)">
                        +1 hour
                    </button>
                    <button *nzSpaceItem nz-button nzSize="large" (click)="selectDelayMinutes(120)">
                        +2 hours
                    </button>
                </nz-space>
            </div>
            <nz-divider></nz-divider>
            <div style="margin-bottom: 20px;">
                <h4>Custom Delay</h4>
                <nz-input-group nzSize="large" [nzSuffix]="minutesSuffix">
                    <input nz-input type="number" [(ngModel)]="delayMinutes" placeholder="Enter minutes" min="1" />
                </nz-input-group>
                <ng-template #minutesSuffix>
                    <span>minutes</span>
                </ng-template>
            </div>
            <div style="margin-bottom: 20px;">
                <h4>Reason (Optional)</h4>
                <nz-select 
                    nzSize="large" 
                    nzShowSearch 
                    nzAllowClear 
                    nzPlaceHolder="Select reason" 
                    [(ngModel)]="delayReason"
                    style="width: 100%;">
                    <nz-option nzLabel="Traffic congestion" nzValue="Traffic congestion"></nz-option>
                    <nz-option nzLabel="Vehicle breakdown" nzValue="Vehicle breakdown"></nz-option>
                    <nz-option nzLabel="Parts not available" nzValue="Parts not available"></nz-option>
                    <nz-option nzLabel="Weather conditions" nzValue="Weather conditions"></nz-option>
                    <nz-option nzLabel="Other emergency" nzValue="Other emergency"></nz-option>
                </nz-select>
            </div>
            @if (delayMinutes && delayMinutes > 0) {
                <nz-alert 
                    nzType="info" 
                    nzShowIcon
                    [nzMessage]="'New ETA: ' + (getUpdatedETA() + 'Z' | date:'HH:mm')"
                    style="margin-bottom: 20px;">
                </nz-alert>
            }

            <nz-space nzDirection="horizontal" style="width: 100%;">
                <button *nzSpaceItem nz-button nzType="default" nzSize="large" nzBlock (click)="isDelayDrawerVisible = false">
                    Cancel
                </button>
                <button *nzSpaceItem nz-button nzType="primary" nzSize="large" nzBlock 
                        [disabled]="!delayMinutes || delayMinutes <= 0"
                        [nzLoading]="isLoading"
                        (click)="confirmLogDelay()">
                    <nz-icon nzType="check-circle" nzTheme="outline" /> Confirm Delay
                </button>
            </nz-space>
        </div>
    </ng-container>
</nz-drawer>

<nz-modal
    [(nzVisible)]="isCompleteWithoutWorkReportConfirmModalVisible"
    nzTitle="Complete Incident Without Work Report"
    (nzOnCancel)="isCompleteWithoutWorkReportConfirmModalVisible = false"
    (nzOnOk)="onClickCompleteWithoutWorkReport()"
    nzOkText="Yes, Complete"
    nzCancelText="Cancel"
    [nzOkLoading]="isLoading"
    nzWidth="450px">
    <ng-container *nzModalContent>
        <nz-alert nzType="warning" nzShowIcon nzMessage="No Work Report Selected" style="margin-bottom: 16px;"
            nzDescription="You are about to complete this incident without attaching a work report. Are you sure you want to proceed?">
        </nz-alert>
    </ng-container>
</nz-modal>

<nz-modal 
    [(nzVisible)]="isIncidentCompleteModalVisible" 
    nzTitle="Incident Ready to Close" 
    (nzOnCancel)="isIncidentCompleteModalVisible = false; this.currentStep = 3" 
    (nzOnOk)="onClickNavigateHome()"
    nzOkText="Home"
    nzCancelText="Continue"
    [nzOkLoading]="isLoading"
    nzWidth="500px">
    <ng-container *nzModalContent>
        <p><strong>The incident is now ready to be closed.</strong></p>
        <p>Click Home to navigate back to the main dashboard. Or click Continue to proceed with the administration of the incident.</p>
    </ng-container>
</nz-modal>

<nz-modal 
    [(nzVisible)]="isSPMapModalVisible" 
    nzTitle="Service Providers on Map" 
    (nzOnCancel)="isSPMapModalVisible = false" 
    (nzOnOk)="isSPMapModalVisible = false"
    nzOkText="Close"
    nzCancelText=""
    [nzOkLoading]="false"
    nzWidth="80%">
    <ng-container *nzModalContent>
        @if ( serviceProviderClients()[0].latitude && serviceProviderClients()[0].longitude ) {
        <app-map-service-providers [serviceProviders]="serviceProviderClients()" [incidentLocation]="incident.location"></app-map-service-providers>
        } @else {
        <div style="display: flex; align-items: center; justify-content: center; height: 400px;">
            <nz-spin nzSimple [nzSize]="'large'"></nz-spin>
        </div>
        }
    </ng-container>
</nz-modal>

<nz-modal
    [(nzVisible)]="isWaGroupOpenerModalVisible"
    nzTitle="WhatsApp Group Messages"
    (nzOnCancel)="isWaGroupOpenerModalVisible = false"
    [nzFooter]="null"
    [nzWidth]="650">
  <ng-container *nzModalContent>
    <app-wa-group-opener
      [incident]="incident"
      [whatsappLink]="waGroupOpenerLink"
      [isFleet]="waGroupOpenerIsFleet"
      [etaOverride]="waGroupOpenerEtaOverride"
      [serviceProviderId]="waGroupOpenerServiceProviderId">
    </app-wa-group-opener>
  </ng-container>
</nz-modal>
